import Vue from 'vue';
import {Model} from '@vuex-orm/core';
import User from "$src/models/userModel";
import ContactPoint from "./contactPointModel";
import Task from "./taskModel";
import PartnerContact from "./partnerContactModel";
import Donation from "./donationModel";

export default class Partner extends Model {
    static entity = 'partner';
    static primaryKey = 'id_partner';

    static fields() {
        return {
            id_partner: this.number(null),
            name: this.string(''),
            identificator: this.string(''),
            role: this.number(0),
            type: this.number(0),
            country_state_origin: this.attr(null),
            country_state_target: this.attr(null),

            newsletter: this.boolean(false),
            privacy_policy: this.boolean(false),
            invitations_regional: this.boolean(false),
            invitations_national: this.boolean(false),
            central_dispatch_letter: this.boolean(false),
            logo_available: this.boolean(false),

            id_user: this.attr(null),
            id_deputy: this.attr(null),
            id_creator: this.attr(null),
            user: this.belongsTo(User, 'id_user', 'id_user'),
            deputy: this.belongsTo(User, 'id_deputy', 'id_user'),
            creator: this.belongsTo(User, 'id_creator', 'id_user'),
            id_address: this.attr(null),
            address: this.attr({
                street: null,
                street_number: null,
                post_code: null,
                city: null,
                country: null,
            }),

            created_at: this.attr(null),
            properties: this.attr({}),
            _entityAuth: this.attr({}),

            contact_points: this.hasMany(ContactPoint, 'id_partner', 'id_partner'),
            tasks: this.hasMany(Task, 'id_partner', 'id_partner'),
            partner_contacts: this.hasMany(PartnerContact, 'id_partner', 'id_partner'),
            donations: this.hasMany(Donation, 'id_partner', 'id_partner'),
        };
    }

    get countryStateOriginString() {
        if (this.country_state_origin == null) {
            return 'Nicht Zugeordnet';
        }
        return Vue.__(`country_state/${this.country_state_origin}`);
    }

    get countryStateTargetString() {
        if (this.country_state_target == null) {
            return 'Freie Verfügung';
        }
        return Vue.__(`country_state/${this.country_state_target}`);
    }

    get partnershipTypeString() {
        if (!this.properties.partnership_type) {
            return null;
        } else {
            let types = this.properties.partnership_type.split(',');
            let translated = [];
            types.forEach(e => {
                translated.push(Vue.__(`partnership_type/${e}`));
            });
            return translated.join(', ');
        }
    }

    static make() {
        return Object.entries(this.fields()).reduce((result, [name, field]) => {
            result[name] = field.value;
            return result;
        }, {});
    }
}